const mutations = {
    setPool(state,payload) {
        state.pools = payload
    }
}

export default mutations